import { NotificationType } from '@weave/schema-gen-ts/dist/shared/notification/notifications.pb';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useWebsocketEventSubscription } from '@frontend/websocket';

export const useWebsocketAppointmentEventSubscription = () => {
  const { invalidateListCalendarEvents } = SchedulerV3.Helpers.useSchedulerV3InvalidateQueries();

  // Invalidate the list of calendar events for the date when an appointment is created, updated or deleted
  return useWebsocketEventSubscription(NotificationType.APPOINTMENT_CHANGED, (payload) =>
    invalidateListCalendarEvents(payload.params.locationId, payload.params.startDatetime)
  );
};
